export function withDefaultAriaLabel(aria, fallback) {
  if (fallback === void 0 || aria?.label !== void 0) {
    return aria;
  }
  return {
    ...aria,
    label: fallback
  };
}